import { WorkInstructionFamilyListPage } from '../work-instructions/WorkInstructionFamilyListPage';
import { WorkInstructionRevisionEditor } from '../work-instructions/WorkInstructionRevisionEditor';
import { PageBanner } from '@/shared/components/PageBanner';
import { useState } from 'react';

export function RoutingWorkInstructionsPage() {
  const [selectedOp, setSelectedOp] = useState<string | null>(null);
  const [selectedFamily, setSelectedFamily] = useState<string | null>(null);

  // In a real app we'd fetch the operations first, but for now we just show a generic placeholder
  // because the instruction said 'put them here'.
  
  return (
    <div dir='rtl' className='p-4 space-y-6'>
      <PageBanner
        title='مدیریت دستورالعمل‌های کاری (SOP)'
        subtitle='تعریف و نسخه‌بندی دستورالعمل‌های تولید'
        icon='📝'
      />
      <div className='brand-card-extand p-6'>
        <p className='text-gray-600 mb-4'>لطفاً شناسه ایستگاه عملیاتی را برای مشاهده دستورالعمل‌ها وارد کنید (این بخش صرفاً برای تست است و در نسخه نهایی به صورت یکپارچه داخل RoutingHomePage قرار می‌گیرد):</p>
        <input 
          className='border p-2 rounded mb-4 w-full' 
          placeholder='شناسه عملیات (Operation ID)...' 
          value={selectedOp || ''}
          onChange={e => setSelectedOp(e.target.value)}
        />
        {selectedOp && (
          <div className='space-y-8'>
             <WorkInstructionFamilyListPage routingOperationId={selectedOp} />
             <div>
               <h3 className='font-bold mb-2'>ایجاد نسخه جدید برای یک خانواده (Family ID را وارد کنید):</h3>
               <input 
                 className='border p-2 rounded mb-4 w-full' 
                 placeholder='شناسه خانواده (Family ID)...' 
                 value={selectedFamily || ''}
                 onChange={e => setSelectedFamily(e.target.value)}
               />
               {selectedFamily && (
                 <WorkInstructionRevisionEditor familyId={selectedFamily} onPublished={() => alert('منتشر شد!')} />
               )}
             </div>
          </div>
        )}
      </div>
    </div>
  );
}
